import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetOrgSummaryResponseDtoSchema = z.object({
  activeUsersByDay: z.array(
    z.object({
      date: z.string(),
      activeUsers: z.number(),
    })
  ),
  topPages: z.array(
    z.object({
      path: z.string(),
      totalDurationSeconds: z.number(),
      viewCount: z.number(),
    })
  ),
});

export type GetOrgSummaryRequestDto = {
  from: string;
  to: string;
};
export type GetOrgSummaryResponseDto = z.infer<
  typeof GetOrgSummaryResponseDtoSchema
>;

export const getOrgSummary = (
  params: GetOrgSummaryRequestDto,
  config?: AxiosRequestConfig<GetOrgSummaryRequestDto>
) => {
  return api
    .get('/tracking/org-summary', { params, ...config })
    .then(responseContract(GetOrgSummaryResponseDtoSchema));
};
